// extracted by mini-css-extract-plugin
export default {"graphicTitle":"dashYear_graphicTitle__7dZrK","fullBox":"dashYear_fullBox__-zNoL","graphicZone":"dashYear_graphicZone__Ne3y5","internalFooter":"dashYear_internalFooter__d3ZkC"};